import React, { Fragment, useEffect } from 'react';
import { connect } from '../../redux/store';
import { actions } from '../../redux/modules/appendix';
import { I18n } from '@kineticdata/react';
import { PageTitle } from '../shared/PageTitle';
import { ContentManager } from '../shared/content_manager/ContentManager';
import { CONTENT_MANAGER_MODE } from '../shared/content_manager/helpers';
import {
  ErrorMessage,
  LoadingMessage,
  C,
  openModalForm,
  selectServicesKappSlug,
} from '@kineticdata/bundle-common';

const AppendixComponent = ({
  portfolioId,
  serviceId,
  appendixId,
  loading,
  error,
  appendix,
  appendixName,
  appendixShortDesc,
  portfolioName,
  serviceName,
  fetchAppendix,
  kappSlug,
  appLocation,
  isMobile,
}) => {
  useEffect(
    () => {
      if (appendixId) {
        fetchAppendix(appendixId);
      }
    },
    [fetchAppendix, appendixId],
  );

  const handleFeedback = () =>
    openModalForm({
      formSlug: C.FORM_SLUG_CATALOG_FEEDBACK,
      kappSlug: kappSlug,
      title: `Provide Appendix Feedback`,
      values: {
        'Catalog Item Id': appendixId,
        'Catalog Item Type': 'Appendix',
        'Catalog Item Name': appendixName,
        'Catalog Item Form Slug': C.FORM_SLUG_APPENDIX,
        'Catalog Submission ID': appendix.id,
      },
      confirmationMessage: 'Your feedback has been submitted.',
      duration: 5000,
    });

  return (
    <Fragment>
      <div className="page-container">
        <div className="page-panel">
          <PageTitle
            className="page-title-heading--sm"
            parts={[
              appendixName,
              serviceName,
              portfolioName,
              'Service Catalog',
            ]}
            suptitle="APPENDIX"
            title={appendixName}
            breadcrumbs={[
              {
                label: (
                  <span>
                    <span className="fa fa-fw fa-md fa-arrow-left text-muted" />
                    <I18n>Service Catalog</I18n>
                  </span>
                ),
                to: `${appLocation}/servicecatalog`,
              },
              portfolioId &&
                portfolioName && {
                  label: portfolioName,
                  to: '../../../..',
                },
              serviceId &&
                serviceName && {
                  label: serviceName,
                  to: '../..',
                },
            ]}
            actions={[
              appendix && {
                label: 'Provide Feedback',
                onClick: handleFeedback,
                menu: true,
              },
            ]}
          >
            {appendixShortDesc && (
              <div className="page-title__meta">{appendixShortDesc}</div>
            )}
          </PageTitle>

          {error ? (
            <ErrorMessage
              title="The appendix failed to load."
              message={error.message}
            />
          ) : loading ? (
            <LoadingMessage />
          ) : !!appendix ? (
            <ContentManager
              submission={appendix}
              mode={CONTENT_MANAGER_MODE.PUBLIC}
              indexSections={true}
              enableSearch={true}
            />
          ) : null}
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state, props) => {
  // Get the appendix, service, and portfolio from the list to get the name
  const appendixFromCatalog = state.app.catalog.appendices.find(
    p => p.values[C.FIELD_APPENDIX_ID] === props.appendixId,
  );
  const serviceFromCatalog = state.app.catalog.services.find(
    p => p.values[C.FIELD_SERVICE_ID] === props.serviceId,
  );
  const portfolioFromCatalog = state.app.catalog.portfolios.find(
    p => p.values[C.FIELD_PORTFOLIO_ID] === props.portfolioId,
  );
  return {
    loading: state.appendix.loading,
    error: state.appendix.error,
    appendix:
      state.appendix.id === props.appendixId ? state.appendix.data : null,
    appendixName: appendixFromCatalog ? appendixFromCatalog.values['Name'] : '',
    appendixShortDesc: appendixFromCatalog
      ? appendixFromCatalog.values['Short Description']
      : '',
    serviceName: serviceFromCatalog ? serviceFromCatalog.values['Name'] : '',
    portfolioName: portfolioFromCatalog
      ? portfolioFromCatalog.values['Name']
      : '',
    kappSlug: selectServicesKappSlug(state),
    appLocation: state.app.location,
    layoutSize: state.app.layoutSize,
    isMobile: ['small', 'medium'].includes(state.app.layoutSize),
  };
};

const mapDispatchToProps = { fetchAppendix: actions.fetchAppendixRequest };

export const Appendix = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AppendixComponent);
